import { render, staticRenderFns } from "./favoriteCheckbox.vue?vue&type=template&id=c8f1ab9e&"
import script from "./favoriteCheckbox.vue?vue&type=script&lang=js&"
export * from "./favoriteCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./favoriteCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports